'use client';

import { twMerge } from 'tailwind-merge';
import { socialIcons } from '../../../utils/socials';
import { appConfig } from '../../../config';
import Link from 'next/link';
import { useState } from 'react';
import Share from '../../components/svg/socials/Share';



export default function SocialsShare({className, postId}: {className?: string; postId: string}) {
  const socials = socialIcons.filter(s => ![1,4,5, 8, 10, 11, 12].includes(s.type));
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={twMerge('hidden tablet:flex gap-[8px] desktop:gap-[16px] [&>*]:grid [&>*]:place-items-center [&>*]:rounded-[4px] rounded-[4px] dark:bg-quaternary [&>*]:w-[24px] p-[8px] [&>*]:aspect-square [&>*]:cursor-pointer', className)}>
    {socials.slice(0, expanded ? undefined : 2).map(({ShareComponent,getShareLink,type, title}) => <Link title={title} key={type} rel='noopener noreferrer' target='_blank' href={getShareLink(`${appConfig.NEXT_PUBLIC_BASE_URL}/${postId}`)}><ShareComponent keepOriginal className='[&>*]:h-[24px] [&>*]:w-[24px]'/></Link>)}
    <Share className='dark:[&>*]:[&>*]:fill-white' onClick={() => setExpanded(!expanded)}/>
    </div>
  )
}